// extracted by mini-css-extract-plugin
export default {"root":"App_root__40Hjl","main":"App_main__nhgh3","navigation":"App_navigation__ndhIK","navigationButton":"App_navigationButton__-O2oV"};